import { Skeleton } from "~/components/ui/skeleton";

export function LocationCardSkeleton() {
  return (
    <div className="bg-white flex flex-col shadow rounded-md p-2">
      <div className="flex flex-col md:flex-row gap-4 relative md:items-start">
        {/* Image placeholder */}
        <Skeleton className="shrink-0 rounded-md w-full md:w-[180px] h-[170px]" />

        {/* Text content */}
        <div className="block grow space-y-2">
          <Skeleton className="h-7 w-3/4 rounded" />
          <Skeleton className="h-5 w-1/3 rounded" />
          <Skeleton className="h-4 w-full rounded" />
          <Skeleton className="h-4 w-5/6 rounded" />

          <div className="flex flex-col gap-1.5 mt-3">
            <div className="flex items-center gap-2">
              <Skeleton className="h-[18px] w-[18px] rounded-full shrink-0" />
              <Skeleton className="h-4 w-28 rounded" />
            </div>
            <div className="flex items-center gap-2">
              <Skeleton className="h-[18px] w-[18px] rounded-full shrink-0" />
              <Skeleton className="h-4 w-32 rounded" />
            </div>
            <div className="flex items-center gap-2">
              <Skeleton className="h-[18px] w-[18px] rounded-full shrink-0" />
              <Skeleton className="h-4 w-24 rounded" />
            </div>
          </div>
        </div>

        {/* Action buttons placeholder */}
        <div className="hidden md:flex md:w-[140px] md:flex-col md:items-stretch md:justify-end gap-1 shrink-0">
          <Skeleton className="h-14 w-14 rounded self-end mb-auto" />
          <Skeleton className="h-9 w-full rounded mt-2" />
          <Skeleton className="h-9 w-full rounded" />
        </div>
      </div>
    </div>
  );
}
